import React, { Fragment, useState, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { Button } from "components";
import { uiActions } from "store";

import closeIcon from "static/images/close-icon.png";
import styles from "./geoLocationPopup.module.scss";

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API;

const Marker = ({ text }) => <div>{text}</div>;
const GeoLocationModal = ({
	title = "add geodata",
	show,
	onHide,
	onSave,
	buttonOk = "Save",
	showOverlay,
	dialogAs,
	backdrop,
	initialLocation,
	addressType,
	isEditable = false,
}) => {
	const dispatch = useDispatch();

	const [selectedLocation, setLocation] = useState({
		lat: null,
		lng: null,
	});

	useEffect(() => {
		if (initialLocation) {
			setLocation(initialLocation);
		} else {
			navigator.geolocation.getCurrentPosition(success, error);
			function success(position) {
				setLocation({
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				});
			}

			function error(err) {
				setLocation({
					lat: 33.4301997,
					lng: parseFloat(-111.9545622, 20),
				});
			}
		}
	}, [initialLocation]);

	const handlePinChange = ({ lat, lng }) => {
		setLocation({ lat, lng });
	};

	const renderMarkers = (map, maps) => {
		const marker = new maps.Marker({
			position: {
				lat: selectedLocation.lat,
				lng: selectedLocation.lng,
			},
			map,
			draggable: true,
		});

		marker.addListener("dragend", () => {
			const position = marker.getPosition();
			handlePinChange({ lat: position.lat(), lng: position.lng() });
		});

		maps.event.addListener(map, "click", event => {
			setLocation({ lat: event.latLng.lat(), lng: event.latLng.lng() });
			if (marker) {
				marker.setPosition({
					lat: event.latLng.lat(),
					lng: event.latLng.lng(),
				});
			}
		});
	};

	const handleSave = async () => {
		try {
			if (showOverlay) dispatch(uiActions.showSpinnerOverlay());
			let payload = {
				latitude: selectedLocation.lat,
				longitude: selectedLocation.lng,
				addressType,
			};
			await onSave(payload);
		} finally {
			if (showOverlay) dispatch(uiActions.hideSpinnerOverlay());
		}
	};

	return (
		<Modal
			className={styles.geoLocationModal}
			show={show}
			onHide={onHide}
			animation={false}
			centered
			dialogAs={dialogAs}
			backdrop={backdrop}
		>
			<Modal.Body className={styles.modal}>
				<div className={styles.modalContent}>
					<div className={styles.wrappCloseIcon}>
						<img src={closeIcon} alt="" onClick={onHide} />
					</div>
					<p className={styles.title}>{title}</p>
					<div className={styles.wrappLocation}>
						<div style={{ height: "70vh", width: "100%" }}>
							{selectedLocation.lat && selectedLocation.lng && (
								<GoogleMapReact
									bootstrapURLKeys={{ key: GOOGLE_API_KEY }}
									center={{
										lat: selectedLocation.lat,
										lng: selectedLocation.lng,
									}}
									zoom={17}
									onGoogleApiLoaded={({ map, maps }) =>
										renderMarkers(map, maps)
									}
									draggable={true}
								>
									<Marker
										lat={selectedLocation.lat}
										lng={selectedLocation.lng}
										text="Selected Location"
									/>
								</GoogleMapReact>
							)}
						</div>
					</div>
					{isEditable && (
						<>
							<p className={styles.notFoundTitle}>
								The provided address was not found. Please put
								point on map
							</p>
							<Button
								value={buttonOk}
								className={styles.btnSave}
								onClick={handleSave}
							/>
						</>
					)}
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default GeoLocationModal;

